export default "/static/webpack/media/clock.ee744609.svg";